/**
 * Interpreta a resposta do POST /policy-document-imports (um arquivo por requisição).
 *
 * - 202 {importBatchId, clientFileId, jobId}: aceito, o progresso chega por socket.
 * - 200 {alreadyImported: true, code: "PDF_JA_IMPORTADO", firstImportedAt, situacao}:
 *   recusado, não há evento de socket nem linha de conferência para o arquivo.
 *
 * Só conta como "ja_importado" quando alreadyImported === true E code === "PDF_JA_IMPORTADO".
 * Qualquer outra forma (inclusive resposta sem os campos) é tratada como aceito.
 */
export function classifyUploadResponse(data, status) {
  if (data && data.alreadyImported === true && data.code === "PDF_JA_IMPORTADO") {
    const quando = data.firstImportedAt ? String(data.firstImportedAt) : "data não informada";
    const situacao = data.situacao ? String(data.situacao) : "situação não informada";
    return {
      kind: "ja_importado",
      message: `Este PDF já foi importado em ${quando} (situação: ${situacao}).`,
    };
  }
  return { kind: "aceito", status };
}
